import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
    mutations: {
      retry: 0,
    },
  },
})

// Event fired right before a branch switch reloads the page. Pages that
// need to flush in-memory state (open dialogs, unsaved drafts, etc.) can
// subscribe via `window.addEventListener('mdg:branch-changed', ...)`.
export const BRANCH_CHANGED_EVENT = 'mdg:branch-changed'

// Force a full page reload after the selected branch changes. The
// `branch-id` request header changes with it, so every cached list
// response is now branch-stale — rather than chase each query key with
// explicit invalidations, reload the page so the entire app boots with
// the new branch context. Callers MUST persist the new branch (via
// `setSelectedBranch`) BEFORE invoking this; otherwise the reload will
// resurrect the previous branch from localStorage.
export function clearBranchScopedCache() {
  try {
    queryClient.removeQueries()
    queryClient.invalidateQueries()
    window.dispatchEvent(new Event(BRANCH_CHANGED_EVENT))
  } catch {
    // Best-effort cleanup; the reload below is what actually flushes the
    // app's view of the previous branch.
  }
  if (typeof window !== 'undefined') {
    window.location.reload()
  }
}
